import { animate, state, style, transition, trigger } from '@angular/animations';

export const opacityAnimation =
  trigger('opacityAnimation', [
    transition(':enter', [
      style([{ opacity: 0 }]),
      animate('1s ease-in-out', style([{ opacity: 1 }])),
    ]),
    state('hide', style({ opacity: 0, })),
    state('show', style({ opacity: 1, })),
    transition('hide => show', [animate('1s')])
  ]);
